var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "photo-page-selector",
      attrs: { "data-testid": "photo-page-selector" },
    },
    [
      _c(
        "v-btn",
        {
          attrs: { icon: "", small: "", disabled: _vm.value === 0 },
          on: { click: _vm.goToFirst },
        },
        [
          _c("v-icon", { attrs: { small: "" } }, [
            _vm._v("fa-angle-double-left"),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-btn",
        {
          attrs: { icon: "", small: "", disabled: _vm.value === 0 },
          on: { click: _vm.goToPrevious },
        },
        [_c("v-icon", { attrs: { small: "" } }, [_vm._v("fa-angle-left")])],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "photo-page-selector__display" }, [
        _c("input", {
          ref: "input",
          staticClass: "photo-page-selector__input",
          attrs: { type: "text" },
          domProps: { value: _vm.displayLabel },
          on: {
            keyup: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              return _vm.handleInput.apply(null, arguments)
            },
          },
        }),
        _vm._v(" "),
        _c("span", { staticClass: "mx-1" }, [_vm._v("/")]),
        _vm._v(" "),
        _c("span", { staticClass: "photo-page-selector__total" }, [
          _vm._v(_vm._s(_vm.max)),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "v-btn",
        {
          attrs: { icon: "", small: "", disabled: _vm.value >= _vm.max },
          on: { click: _vm.goToNext },
        },
        [_c("v-icon", { attrs: { small: "" } }, [_vm._v("fa-angle-right")])],
        1
      ),
      _vm._v(" "),
      _c(
        "v-btn",
        {
          attrs: { icon: "", small: "", disabled: _vm.value >= _vm.max },
          on: { click: _vm.goToLast },
        },
        [
          _c("v-icon", { attrs: { small: "" } }, [
            _vm._v("fa-angle-double-right"),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }